import { HttpClient } from 'core/common/services';
import { ContentData, ContentManagerService } from './ContentManager';

export class ContentManagerServerService implements ContentManagerService {
  constructor(private readonly httpClient: HttpClient) {}

  async getContent(url: string): Promise<ContentData> {
    const response = await this.httpClient.get<ContentData>(url);

    return response;
  }
}
